import { Component } from 'react';

class FocusedPanel extends Component {
  render() {
    const { children } = this.props;

    return <div className="FocusedPanel">{children}</div>;
  }
}

export default FocusedPanel;
